import { yellow } from '@mui/material/colors';

import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';

export interface AssetSearchHighlightProps {
  text: string;
  search: string;
  variant: Variant;
}

function AssetSearchHighlight(props: AssetSearchHighlightProps) {
  const { text, search: _search, variant } = props;

  const search = _search.trim();
  if (search === '') {
    return <Typography variant={variant}>{text}</Typography>;
  }

  const rx = new RegExp(search, 'gi');

  let match,
    index = 0;

  const items = [];

  while ((match = rx.exec(text)) !== null) {
    items.push(
      <Typography
        key={`highlight-before-${index}`}
        component="span"
        variant={variant}
      >
        {text.slice(index, rx.lastIndex - search.length)}
      </Typography>,
    );
    items.push(
      <Typography
        key={`highlight-match-${index}`}
        component="span"
        variant={variant}
        sx={{ backgroundColor: yellow[300] }}
      >
        {match[0]}
      </Typography>,
    );
    index = rx.lastIndex;
  }

  items.push(
    <Typography
      key={`highlight-after-${index}`}
      component="span"
      variant={variant}
    >
      {text.slice(index, text.length)}
    </Typography>,
  );

  return <Typography variant={variant}>{items}</Typography>;
}

export { AssetSearchHighlight };
